export const data = {
    "food": {
        name: "Food",
        img: "https://cdn.shopify.com/s/files/1/0529/2461/2804/articles/cheesy-nacho-new-3_1500x.jpg?v=1639402520",
        articles: [{
            title: "50 famous foods to try in your lifetime",
            author: "Darcy Schild",
            img: "https://i.insider.com/5d4203fb36e03c28a1020308?width=2000&format=jpeg&auto=webp",
            intro: "From iconic desserts like Belgian waffles to savory dishes such as dim sum, pad thai, and Polish pierogies, just about every corner of the world is packed with famous eateries and must-try foods.",
            url: "https://www.insider.com/famous-foods-meals-to-eat-in-life-2019-8"
        }, {
            title: "25 foods you should try at least once",
            author: "Natalie Hardwick",
            img: "https://images.immediate.co.uk/production/volatile/sites/30/2020/08/kimchi_in_jar_and_bowl-fd70649.jpg?quality=90&webp=true&resize=600,545",
            intro: "Food trends come and go, but some ingredients are mainstays of the ‘foodie’ scene. Chefs love pushing the envelope and introducing diners to curios, from unusual cuts of meat to global dishes and wince-worthy animal innards. We’ve picked 25 underused foods to sample at least once…",
            url: "https://www.bbcgoodfood.com/howto/guide/25-foods-you-should-try-least-once"
        }, {
            title: "50 Foods Around the World to Try Before You Die",
            author: "Lissa Poirot",
            img: "https://thumbor.granitemedia.com/img/7bAc50o5ZLHIfWQk8WUnMINeNr0=/800x600/filters:quality(80)/granite-web-prod/39/41/3941779ccef04d829eba5ba461a0a928.jpeg",
            intro: "One of the best things about travel is being introduced to new foods. But when there are so many foods to try, it can be difficult to know where to begin.",
            url: "https://www.farandwide.com/s/best-foods-world-55677ab596354f02"
        }],
        video: ["https://www.youtube.com/embed/jGKHJEnt0Mo", "https://www.youtube.com/embed/0SPwwpruGIA", "https://www.youtube.com/embed/1VZdAU2oIrY"]
    },
    "travel": {
        name: "Travel",
        img: "https://earrialk.sirv.com/travel.jpeg",
        articles: [{
            title: "The Top 50 Places In The World",
            author: "Laura Begley Bloom",
            img: "https://imageio.forbes.com/specials-images/dam/imageserve/1171238184/960x0.jpg?fit=bounds&format=jpg&width=960",
            intro: "What's on your travel bucket list? If you're like most people, the more you travel, the more places you add to your bucket list. So when the editors of the website Big 7 Travel announced the list of the world's top 50 bucket list destinations, we stopped in our tracks and started checking off the boxes.",
            url: "https://www.forbes.com/sites/laurabegleybloom/2019/09/04/bucket-list-travel-the-top-50-places-in-the-world/?sh=97f943420cfd"
        }, {
            title: "25 Truly Amazing Places To Visit Before You Die",
            author: "Alicia Rades",
            img: "",
            intro: "Studies show that travel can make you smarter and healthier. So now grab a sheet of paper and a pencil, ladies and gentlemen. (Or in more modern terms, create a new note on Evernote.) It’s time to create that bucket list you’ve been meaning to write up:",
            url: "https://www.lifehack.org/articles/lifestyle/25-truly-amazing-places-you-must-visit-before-you-die.html"
        }, {
            title: "World's Best Places to Visit",
            author: "",
            img: "",
            intro: "With a world full of fascinating destinations, choosing the perfect vacation spot can present a challenge. That's why U.S. News used expert opinions, reader votes and current trends – and evaluated sights, cultures, scenic beauty, food scenes and more – to compile this list of the world's best places to visit. Use these recommendations to craft your travel bucket list, and cast your vote below to help us determine next year's list.",
            url: "https://travel.usnews.com/rankings/worlds-best-vacations/"
        }],
        video: ["https://www.youtube.com/embed/Hmu4bQxfpDA","https://www.youtube.com/embed/9lhAp5LmZm8","https://www.youtube.com/embed/OHAWwaYu2H0"]
    },
    "daily-routine": {
        name: "Daily Routine",
        img: "https://earrialk.sirv.com/Finger%20Flop%20%5Bprocess%5D.gif",
        articles: [{
            title: "12 HEALTHY DAILY HABITS",
            author: "RED",
            img: "https://kaynutrition.com/wp-content/uploads/2020/07/healthy-daily-habits.png",
            intro: "Creating a healthy daily routine is a simple yet effective way to build consistency when it comes to your health. Not only does your daily routine impact your overall health, but it has a direct impact on your stress levels, sleep habits and eating patterns.",
            url: "https://kaynutrition.com/healthy-daily-habits/"

        }, {
            title: "Powerful Daily Routine Examples for a Healthier Life",
            author: "Leon Ho",
            img: "",
            intro: "Big or small, healthy or unhealthy, our habits combine to form routines that play out every day for us. Most of this is done without us even having to think. That’s why, even though we understand the importance of having good habits, sometimes it’s tough to stick to a healthy daily routine.",
            url: "https://www.lifehack.org/677367/powerful-daily-routine"
        }, {
            title: "30 daily routines of healthy, productive people that are easy to adopt",
            author: "Laura Berlinsky-Schine",
            img: "https://www.theladders.com/wp-content/uploads/Morning_Routine_032618-800x450.jpg",
            intro: "Small changes can have a big impact. That’s certainly true of routines. While some people believe that developing a concrete schedule is too difficult, even implementing minor alterations to your daily life can have enormous, positive consequences.",
            url: "https://www.theladders.com/career-advice/30-daily-routines-of-healthy-productive-people-that-are-easy-to-adopt"
        }],
        video: ["https://www.youtube.com/embed/GaJ4BKcDGiM","https://www.youtube.com/embed/brV7k1ZgexE","https://www.youtube.com/embed/rAOdpaQfFBQ"]
    },
    "music": {
        name: "Music",
        img: "https://earrialk.sirv.com/ezgif.com-gif-maker%20(1).gif",
        articles: [{
            title: "The 40 best albums to listen to before you die",
            author: "Helen Brown, Chris Harvey and Roisin O’Connor",
            img: "https://static.independent.co.uk/s3fs-public/thumbnails/image/2018/11/22/10/album-covers.jpg?quality=75&width=990&auto=webp&crop=982:726,smart",
            intro: "When was the last time you listened to an old album from start to finish? With our ears set to shuffle since the death of the CD, only the vinyl fetishists seem to do it any more. ",
            url: "https://www.independent.co.uk/arts-entertainment/music/features/best-albums-greatest-all-time-b1989883.html"
        }, {
            title: "101 Albums To Hear Before You Die",
            author: "NME",
            img: "",
            intro: "These days, there’s more good music available at your fingertips than you could ever hope to listen to. Confused as to where to begin? We don’t blame you. But there are some albums so seminal, so integral to the core of modern sound or just so damned brilliant that you need to get them on your musical bucket list: End. Of. Here are 100 of the finest…",
            url: "https://www.nme.com/list/101-albums-to-hear-before-you-die-1259"
        }, {
            title: "30 Albums You Should Listen To",
            author: 'J.A. Shapira',
            img: 'https://www.gentlemansgazette.com/wp-content/uploads/2015/01/30-Albums-You-Should-Listen-To-1350x513.jpg',
            intro: "During a quick internet search I figured out there is a little over 14 million tracks available for sale on iTunes. Now, of course iTunes doesn’t have nearly all of the songs ever distributed for sale so if we assume that’s only half of all the songs ever sold, and there’s approximately eleven songs on each album, it gives us a loosy-goosy number of approximately 2.55 million albums sold around the world.",
            url: "https://www.gentlemansgazette.com/albums-you-should-listen/"
        }],
        video: ["https://www.youtube.com/embed/-7jjo8UICjQ","https://www.youtube.com/embed/SpWHkXt7tnI","https://www.youtube.com/embed/l7c1R6v0E1g"]
    }
  }

export const testFamily = {
    husband: {
      name: "John",
      relationship: "Husband",
      dob: "01/01/1950",
      address: "123 A St",
      phone: "0147258369",
      img: "https://earrialk.sirv.com/kibooki%20on%20Twitter-2.jpg"
    },
    daughter: {
      name: "Emily",
      relationship: "daughter",
      dob: "02/02/1980",
      address: "456 B St",
      phone: "0192837465",
      img: "https://earrialk.sirv.com/Michi%2C%20Ina%20Ortega-2.png"
    },
    son: {
      name: "Sam",
      relationship: "Son",
      dob: "03/03/1984",
      address: "789 C St",
      phone: "0987654321",
      img: "https://earrialk.sirv.com/Bankwest_%20App%20Tracker.jpg"
    },
    granddaughter: {
      name: "Elisa",
      relationship: "Grand-daughter",
      dob: '04/04/2005',
      address: "456 B St",
      phone: "0123456789",
      img: "https://earrialk.sirv.com/Natural%20girl%2C%20Javier%20Benver.png"
    }
  }
export const testFriend = {
    1: {
      name: "Kellie",
      relationship: "Best Friend 1",
      dob: "01/01/1950",
      address: "123 A St",
      phone: "0147258369",
      img: "https://earrialk.sirv.com/kibooki%20on%20Twitter-2.jpg"
    },
    2: {
      name: "Emma",
      relationship: "Best Friend 2",
      dob: "02/02/1980",
      address: "456 B St",
      phone: "0192837465",
      img: "https://earrialk.sirv.com/Michi%2C%20Ina%20Ortega-2.png"
    },
    3: {
      name: "May",
      relationship: "Best Friend 3",
      dob: "03/03/1984",
      address: "789 C St",
      phone: "0987654321",
      img: "https://earrialk.sirv.com/Bankwest_%20App%20Tracker.jpg"
    },
    4: {
      name: "Stephan",
      relationship: "Best Friend 4",
      dob: '04/04/2005',
      address: "456 B St",
      phone: "0123456789",
      img: "https://earrialk.sirv.com/Natural%20girl%2C%20Javier%20Benver.png"
    }
  }